module.exports = "/_next/static/images/icon-brochure-cfb07661727d22a2945e14dff7daac57.png";